import React, { ChangeEventHandler } from 'react';

import { css } from '@emotion/css';
import { Input } from '@opendoor/bricks/core';

import { getReadableCurrency } from '../../helpers/getAllParnLeadData';

const styles = {
  text_label_bottom_padding: css`
    padding-bottom: 7px;
  `,
  field_bottom_padding: css`
    padding-bottom: 25px;
    width: 100%;
  `,
};

interface ParnInputFieldProps {
  id: string;
  name: string;
  label?: string;
  placeholder?: string;
  value?: number;
  eventHandler: ChangeEventHandler<HTMLInputElement>;
  analyticsName: string;
}

// storybook-check-ignore
export const ParnInputField: React.FC<ParnInputFieldProps> = ({
  id,
  name,
  label,
  placeholder,
  value,
  eventHandler,
  analyticsName,
}) => {
  return (
    <div className={styles.field_bottom_padding}>
      <Input
        id={id}
        name={name}
        label={label}
        placeholder={placeholder}
        value={getReadableCurrency(value, '')}
        onChange={(e) => e && eventHandler(e)}
        analyticsName={analyticsName}
        type="text"
        orientation="vertical"
        unboundedWidth={true}
        width="100%"
        required
      />
    </div>
  );
};

export default ParnInputField;
